// extracted by mini-css-extract-plugin
module.exports = {"Features":"styles_Features__30PUS","items":"styles_items__6HN1K","title":"styles_title__fGAlZ","item":"styles_item__fv_Yf","two":"styles_two__ZjPJY"};